/** Recording-active indicator: red mic button with ripple waves and heartbeat animation. */
export const RECORDING_INDICATOR_CSS = `
    .pw-recording-indicator {
      position: absolute;
      bottom: 88px; right: 12px;
      width: 44px; height: 44px;
      display: flex; align-items: center; justify-content: center;
      pointer-events: auto;
      z-index: 40;
      transform-origin: center bottom;
      animation: pw-recording-enter 0.34s cubic-bezier(0.34, 1.56, 0.64, 1) both;
    }

    @keyframes pw-recording-enter {
      0%   { opacity: 0; transform: scale(0.4) translateY(14px); }
      60%  { opacity: 1; transform: scale(1.08) translateY(0); }
      100% { opacity: 1; transform: scale(1) translateY(0); }
    }

    .pw-recording-indicator::before,
    .pw-recording-indicator::after {
      content: '';
      position: absolute;
      top: 50%; left: 50%;
      width: 44px; height: 44px;
      border-radius: 50%;
      border: 1.5px solid rgba(229, 62, 62, 0.55);
      transform: translate(-50%, -50%) scale(1);
      opacity: 0;
      animation: pw-recording-wave 2.4s ease-out infinite;
      pointer-events: none;
    }
    .pw-recording-indicator::after {
      animation-delay: 1.2s;
    }

    .pw-recording-wave-3 {
      position: absolute;
      top: 50%; left: 50%;
      width: 44px; height: 44px;
      border-radius: 50%;
      border: 1px solid rgba(229, 62, 62, 0.3);
      transform: translate(-50%, -50%) scale(1);
      opacity: 0;
      animation: pw-recording-wave 2.4s ease-out infinite;
      animation-delay: 0.6s;
      pointer-events: none;
    }

    @keyframes pw-recording-wave {
      0%   { transform: translate(-50%, -50%) scale(1);    opacity: 0.6; }
      100% { transform: translate(-50%, -50%) scale(1.55); opacity: 0; }
    }

    .pw-recording-btn {
      width: 44px; height: 44px; border-radius: 50%;
      background: linear-gradient(135deg, #DC5555 0%, #D32B2B 100%);
      backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px);
      border: 1px solid rgba(229, 62, 62, 0.6);
      display: flex; align-items: center; justify-content: center;
      cursor: pointer; position: relative; z-index: 1;
      box-shadow: 0 1px 7.7px rgba(0, 0, 0, 0.16);
      transition: all 0.3s ease;
      animation: pw-recording-heartbeat 1.6s ease-in-out infinite;
      outline: none;
      padding: 0;
    }
    .pw-recording-btn:hover {
      background: linear-gradient(135deg, #c44a4a 0%, #b82424 100%);
      box-shadow: 0 2px 12px rgba(211, 43, 43, 0.4);
    }
    .pw-recording-btn svg {
      width: 20px; height: 20px; color: #ffffff; display: block;
    }
    .pw-recording-btn svg path {
      stroke-width: 1.5;
    }

    @keyframes pw-recording-heartbeat {
      0%   { transform: scale(1);    box-shadow: 0 1px 7.7px rgba(0, 0, 0, 0.16); }
      14%  { transform: scale(1.08); box-shadow: 0 2px 12px rgba(229, 62, 62, 0.22); }
      28%  { transform: scale(1);    box-shadow: 0 1px 7.7px rgba(0, 0, 0, 0.16); }
      42%  { transform: scale(1.05); box-shadow: 0 2px 10px rgba(229, 62, 62, 0.15); }
      56%  { transform: scale(1);    box-shadow: 0 1px 7.7px rgba(0, 0, 0, 0.16); }
      100% { transform: scale(1);    box-shadow: 0 1px 7.7px rgba(0, 0, 0, 0.16); }
    }

    /* Live perio: the Perio leaf itself is the recording control (notes-red). */
    .pw-ic.pw-recording-leaf {
      opacity: 1;
      transform: translateY(0) scale(1);
      pointer-events: auto;
    }
    .pw-ic.pw-recording-leaf::before,
    .pw-ic.pw-recording-leaf::after {
      content: '';
      position: absolute;
      top: 50%; left: 50%;
      width: 44px; height: 44px;
      border-radius: 50%;
      border: 1.5px solid rgba(229, 62, 62, 0.55);
      transform: translate(-50%, -50%) scale(1);
      opacity: 0;
      animation: pw-recording-wave 2.4s ease-out infinite;
      pointer-events: none;
    }
    .pw-ic.pw-recording-leaf::after {
      animation-delay: 1.2s;
    }
    .pw-ic.pw-recording-leaf .pw-ic-btn {
      width: 44px; height: 44px;
      background: linear-gradient(135deg, #DC5555 0%, #D32B2B 100%);
      border: 1px solid rgba(229, 62, 62, 0.6);
      box-shadow: 0 1px 7.7px rgba(0, 0, 0, 0.16);
      animation: pw-recording-heartbeat 1.6s ease-in-out infinite;
    }
    .pw-ic.pw-recording-leaf:hover .pw-ic-btn,
    .pw-ic.pw-recording-leaf.pw-open .pw-ic-btn,
    .pw-ic.pw-recording-leaf .pw-ic-btn:focus-visible {
      width: 44px; height: 44px;
      background: linear-gradient(135deg, #c44a4a 0%, #b82424 100%);
      box-shadow: 0 2px 12px rgba(211, 43, 43, 0.4);
    }
    .pw-ic.pw-recording-leaf .pw-ic-btn img,
    .pw-ic.pw-recording-leaf:hover .pw-ic-btn img,
    .pw-ic.pw-recording-leaf.pw-open .pw-ic-btn img,
    .pw-ic.pw-recording-leaf .pw-ic-btn:focus-visible img {
      width: 20px; height: 20px;
      filter: brightness(0) invert(1);
    }

    /* SCRIBE-965 B: Voice stays hoverable (tooltip) but looks paused. */
    .pw-ic.pw-voice-held {
      opacity: 1;
      transform: translateY(0) scale(1);
      pointer-events: auto;
    }
    .pw-ic.pw-voice-held .pw-ic-btn {
      cursor: not-allowed;
      opacity: 0.72;
    }
    .pw-ic.pw-voice-held .pw-ic-btn,
    .pw-ic.pw-voice-held:hover .pw-ic-btn,
    .pw-ic.pw-voice-held .pw-ic-btn:focus-visible {
      pointer-events: auto;
    }
`;
